export default __webpack_public_path__ + "3f213c31bdf9e6a4357890bf547d4004.svg";